import { OverTimeSegmentedVizViews } from '../types';
import { overTimeSegmentedBarChartViewConfig } from './bar-chart/view-config';
import { overTimeSegmentedLineChartViewConfig } from './line-chart/view-config';
import { overTimeTableViewSegmentedViewConfig } from './table-view/view-config';

export const overTimeViewConfigs = [
  {
    name: OverTimeSegmentedVizViews.LINE_CHART,
    viewConfig: overTimeSegmentedLineChartViewConfig,
  },
  {
    name: OverTimeSegmentedVizViews.TABLE_VIEW,
    viewConfig: overTimeTableViewSegmentedViewConfig,
  },
  {
    name: OverTimeSegmentedVizViews.BAR_CHART,
    viewConfig: overTimeSegmentedBarChartViewConfig,
  },
];
